<template>
  <div class="view-container">
    <!-- Show spash screen -->
    <div v-if="showLoader">
      <app-loader :fadeoutLoader="fadeoutLoader"></app-loader>
    </div>
    <div v-if="fadeoutLoader"></div>
    <gmap-map :center="center" :zoom="14" :options="{
      zoomControl: true,
      fullscreenControl: true,
      mapTypeControl: false,
      scaleControl: false,
      streetViewControl: false,
      rotateControl: false,
      disableDefaultUi: false,
    }">
      <gmap-marker :key="index" v-for="(gmp, index) in markers" :position="gmp" :clickable="true" :icon="gmp.icon"
        @click="center = gmp"></gmap-marker>
    </gmap-map>
    <div class="view-content-container">
      <div class="input-group mb-3">
        <div class="input-group-prepend">
          <span class="input-group-text" id="basic-addon1"><i class="fa fa-search"></i></span>
        </div>
        <input ref="search" type="text" class="form-control" placeholder="What are you looking for?"
          aria-describedby="basic-addon1" v-model="searchText" />
        <transition name="fade">
          <span v-if="searchText" class="input-group-append">
            <button @click="clearSearchText()" class="btn btn-outline-secondary border-left-0 border" type="button">
              <i class="fa fa-times"></i>
            </button>
          </span>
        </transition>
      </div>
      <div class="content-container">
        <div v-if="searching" name="loader-container" class="row">
          <div class="loader-container">
            <img src="@/assets/Loading_icon.gif" class="loader-icon" width="250" height="150" alt="Loading..." />
          </div>
        </div>
        <div v-show="!searching">
          <p v-if="!coordinates" class="content-paragraph">
            We recommend enabling geolocation.
          </p>
          <ul v-if="searchResults.length > 0" class="franchise-locations">
            <li v-for="branch in searchResults" :key="branch.id" :data-fid="branch.franchiseID" :data-bid="branch.id"
              :data-lat="branch.latitude" :data-lng="branch.longitude" @click.stop="selectBranch">
              <img :src="branch.franchise.franchiseLogoURL" class="branch-logo" />
              <span class="branch-name">{{ branch.name }}</span>
              <i class="fa fa-map-marker btn" @click.stop.prevent="centerMap"></i>
              <span class="branch-distance" @click.stop.prevent="centerMap">{{ branch.distanceText }}</span>
              <span class="branch-subDepartments">
                <span v-for="(subDepartment, index) in branch.subDepartments" :key="subDepartment.id">
                  {{ subDepartment.name }} {{ branch.subDepartments.length - 1 == index ? '' : '•' }}</span>
              </span>
            </li>
          </ul>
          <p v-else-if="searchText" class="content-paragraph">No search results were found.</p>
        </div>
      </div>
    </div>
  </div>
</template>
<!-- Scripts -->
<script>
import loaderPartial from "@/components/LoaderPartial.vue";
import { splashScreen } from "@/mixins/splashScreen";
import _ from 'lodash'

export default {
  name: "Explore",
  components: {
    "app-loader": loaderPartial,
  },
  mixins: [splashScreen],
  data() {
    return {
      publicPath: process.env.BASE_URL,
      searchResults: [],
      originalBranches: [],
      branches: [],
      franchisesNearMe: [],
      franchises: [],
      coordinates: null,
      center: {
        lat: 39.7837304,
        lng: -100.4458825,
      },
      markers: [],
      originalMarkers: [],
      searchText: "",
      searching: false,
    };
  },
  watch: {
    searchText: _.debounce(function (value) {
      var _self = this;
      _self.markers = [];

      if (!value) {
        _self.searchResults = _self.originalBranches;
        _self.markers = _self.originalMarkers;
        return;
      }

      if (_self.coordinates)
        _self.markers.push(_self.center);

      var parameters = {
        SearchText: value,
        Lat: _self.center.lat,
        Lng: _self.center.lng,
      };

      _self.searching = true;
      this.$ooApi.orders.maps.search.v1(parameters)
        .then(async function (result) {
          _self.branches = result.data.branches;
          _self.branches.forEach(function (item) {
            item.franchise = result.data.franchises.find(
              (element) => element.id == item.franchiseID
            );
            item.subDepartments = result.data.subDepartments.filter(
              (element) => element.franchiseID == item.franchiseID
            );

            var location = {
              lat: item.latitude,
              lng: item.longitude,
              icon: {
                url: window.config.ApiUrl + "/images/platinum-map-marker.png",
                scaledSize: {
                  height: 40,
                  width: 40,
                },
              },
            };
            _self.markers.push(location);
          });

          if (!_self.coordinates && _self.markers.length > 0)
            _self.center = _self.markers[0];

          _self.searchResults = _self.branches
          _self.searching = false;
        });
    }, 800)
  },
  created() {
    var _self = this;

    _self.initialize();
    _self.getLocation();
  },
  mounted: function () {
    this._self.clearComputed();
    this.setLocationLatLng();

    var bodyHeight = document.body.clientHeight;
    var menuHeight = document.querySelector('#menuFranchise').clientHeight;
    var mapHeight = document.querySelector('.vue-map-container').clientHeight;

    document.querySelector('.content-container').style.height = bodyHeight - menuHeight - mapHeight - 51 + 'px';
  },
  methods: {
    initialize: function () {
      return new Promise((resolve, reject) => {
        var _self = this;

        if (!_self.$frachiseID) _self.initSplashScreen();

        this.$ooApi.orders.franchises
          .v1()
          .then(function (result) {
            _self.$franchiseLogoUrl = result.data.platinumLogoPath;
            _self.$franchiseBannerUrl = result.data.platinumOnlineBannerPath;
            _self.$franchiseAccentColor = result.data.platinumAccentColor;
            _self.franchises = result.data.franchises;
          })
          .then(function () {
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getLocation: function () {
      var _self = this;
      navigator.geolocation.getCurrentPosition(
        (position) => {
          _self.coordinates = position.coords;
        },
        (error) => {
          console.log(error.message);
        }
      );
    },
    setLocationLatLng: function () {
      var _self = this;
      navigator.geolocation.getCurrentPosition((geolocation) => {
        this.center = {
          lat: geolocation.coords.latitude,
          lng: geolocation.coords.longitude,
          icon: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjMiIGhlaWdodD0iMjkiIHZpZXdCb3g9IjAgMCAyMyAyOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik0yMyAxMS41QzIzIDIxLjUgMTEuNSAyOC41IDExLjUgMjguNUMxMS41IDI4LjUgMCAyMS41IDAgMTEuNUMwIDUuMTQ4NzMgNS4xNDg3MyAwIDExLjUgMEMxNy44NTEzIDAgMjMgNS4xNDg3MyAyMyAxMS41WiIgZmlsbD0iI0M3MDYyOSIvPg0KPGNpcmNsZSBjeD0iMTEuNSIgY3k9IjExLjUiIHI9IjUuNSIgZmlsbD0iIzgxMDAxNyIvPg0KPC9zdmc+DQo=",
        };
        this.markers.push(this.center);

        var data = {
          Lat: this.center.lat,
          Lng: this.center.lng,
        };
        _self.$ooApi.orders.maps.closest
          .v1(data)
          .then(function (result) {
            _self.branches = result.data.branches;
            _self.branches.forEach(function (item) {
              item.franchise = result.data.franchises.find(
                (element) => element.id == item.franchiseID
              );
              item.subDepartments = result.data.subDepartments.filter(
                (element) => element.franchiseID == item.franchiseID
              );
              var location = {
                lat: item.latitude,
                lng: item.longitude,
                icon: {
                  url: window.config.ApiUrl + "/images/platinum-map-marker.png",
                  scaledSize: {
                    height: 40,
                    width: 40,
                  },
                  // origin: {
                  //   x: 0,
                  //   y: 0
                  // },
                  // anchor: {
                  //   x: 0,
                  //   y: 0
                  // }
                },
              };
              _self.markers.push(location);
            });
            _self.branches.sort((a, b) => {
              return a.distance - b.distance;
            });
            _self.originalMarkers = _self.markers;
            _self.originalBranches = _self.branches;
            _self.searchResults = _self.branches;
          });
      });
    },
    getBase64Image: function (img) {
      var canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;
      var ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0);
      var dataURL = canvas.toDataURL("image/png");
      return dataURL.replace(/^data:image\/(png|jpg);base64,/, "");
    },
    centerMap: function (e) {
      var target = e.target;
      if (e.target.tagName.toLowerCase() != "li")
        target = e.target.closest("li");

      this.center = {
        lat: parseFloat(target.getAttribute("data-lat")),
        lng: parseFloat(target.getAttribute("data-lng")),
      };
    },
    selectBranch: function (e) {
      var target = e.target;
      if (e.target.tagName.toLowerCase() != "li")
        target = e.target.closest("li");

      this.$router.push({
        path: "Menu",
        query: {
          franchiseID: target.getAttribute("data-fid"),
          branchID: target.getAttribute("data-bid"),
        },
      });
    },
    clearSearchText: function () {
      this.searchText = '';
      this.$refs.search.focus();
    },
  },
};
</script>
<style scoped>
@import "./Explore.vue.css";
</style>
